import React from 'react';
import styled from 'styled-components';
import { Sparkles } from 'lucide-react';
import { EVENTO_ALTERNAR_ASSISTENTE, useInsights } from './InsightsProvider';

const Botao = styled.button`
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 0;
  background: #1f467e;
  color: #fff;
  box-shadow: 0 8px 20px rgba(31, 70, 126, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
  transition: transform 0.15s;

  &:hover { transform: scale(1.05); }

  @media (max-width: 480px) {
    right: 16px;
    bottom: 16px;
  }
`;

const Contador = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border-radius: 11px;
  background: #c2410c;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  box-sizing: border-box;
`;

/** Avatar fixo do assistente no canto: abre (ou fecha) o painel na aba Insights. */
export const AvatarAssistente: React.FC = () => {
  const { habilitado, itens } = useInsights();
  if (!habilitado) return null;

  const pendentes = itens.length;
  return (
    <Botao
      type="button"
      aria-label={pendentes > 0 ? `Abrir assistente, ${pendentes} insights` : 'Abrir assistente'}
      title="Assistente"
      onClick={() => window.dispatchEvent(new Event(EVENTO_ALTERNAR_ASSISTENTE))}
    >
      <Sparkles size={26} />
      {pendentes > 0 && <Contador>{pendentes > 9 ? '9+' : pendentes}</Contador>}
    </Botao>
  );
};
